export enum LoadingDotsStyle {
    Default = 'default',
    Dark = 'dark',
}
